/**
 * GZip Compression specific types
 * Based on data model from specs/003-encoders-decoders-tools/data-model.md
 */

export const GZipMode = {
  COMPRESS: 'compress',
  DECOMPRESS: 'decompress'
} as const;

export type GZipMode = typeof GZipMode[keyof typeof GZipMode];

export const GzipFormat = {
  GZIP: 'gzip',
  DEFLATE: 'deflate',
  RAW: 'raw'
} as const;

export type GzipFormat = typeof GzipFormat[keyof typeof GzipFormat];

export const GzipLevel = {
  DEFAULT: 6,
  NONE: 0,
  FASTEST: 1,
  FAST: 3,
  GOOD: 7,
  BEST: 9
} as const;

export type GzipLevel = typeof GzipLevel[keyof typeof GzipLevel];

export interface GZipConfiguration {
  input: string | Uint8Array;
  mode: GZipMode;
  level?: number;
  filename?: string;
  timestamp?: number;
  comment?: string;
  outputFormat?: 'base64' | 'hex' | 'uint8array';
}

export interface CompressionResult {
  id: string;
  originalData: string;
  compressedData: Uint8Array;
  originalSize: number;
  compressedSize: number;
  compressionRatio: number;
  compressionLevel: number;
  operationType: 'compress' | 'decompress';
  processedAt: Date;
  status: 'success' | 'error';
  errorMessage?: string;
}

export interface GzipCompressionMetrics {
  originalSize: number;
  compressedSize: number;
  compressionRatio: number;
  compressionLevel: number;
  processingTime: number;
}

export interface GzipBatchResult {
  id: string;
  results: CompressionResult[];
  totalOriginalSize: number;
  totalCompressedSize: number;
  averageCompressionRatio: number;
  processedAt: Date;
}